module.exports = __webpack_public_path__ + "static/media/do.4ba64fb6.svg";